import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ShowAiYearLogo} from '../Redux/action';
import messages_en from '../Translations/en.json';
import messages_ar from '../Translations/ar.json';

class AiYearLogoToggle extends Component {
	toggleAiYearLogo = (e) => {
		this.props.showAiYearLogo(e.target.checked);
	};

	render() {
		const isRtl = this.props.language_web === 'العربية';
		const messages = isRtl ? messages_ar : messages_en;

		return (
				<div
						className="mt-2 mb-2"
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '0.5rem',
							direction: isRtl ? 'rtl' : 'ltr',
						}}
				>
					<input
							type="checkbox"
							id="aiYearLogo"
							checked={this.props.showAiYear}
							onChange={this.toggleAiYearLogo}
					/>
					<label htmlFor="aiYearLogo" className='mb-0'>
						{messages['image.ai-year']}
					</label>
				</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		showAiYear: state.imageReducer.showAiYearLogo,
		language_web: state.LanguageReducer.languageWeb,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		showAiYearLogo: (show) => dispatch(ShowAiYearLogo(show)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AiYearLogoToggle);
